module.exports = __webpack_public_path__ + "static/media/19ESCAP14.d9dae528.jpg";